// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".graph-list[data-v-3b327b12] {\n  width: 100%;\n  margin-bottom: 25px;\n}\n.graph-list .chart-graph[data-v-3b327b12] {\n  height: 600px;\n}", ""]);
// Exports
module.exports = exports;
